export default "__VITE_ASSET__CPi87vmt__"